'use strict';

angular.module('cloudBillingLegacyFrontend').controller('CbTeamsAreaCtrl', function ($scope, $eaCurrentSession, $stateParams) {
  
  $scope.currentSession = $eaCurrentSession;  
  $scope.token = $eaCurrentSession.DataToken;
  $scope.tenantId = $stateParams.teamid;
});
